import React, { Component } from 'react';
import Home from "./components/Home";
import Login from "./components/Login"

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import './App.css';

class App extends Component {
  componentDidMount() {
    document.title = "PlndrPlay - Win for Real";

  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <div style={{display: "none"}}>
              Build Number: {`${process.env.REACT_APP_CODEBUILD_BUILD_NUMBER}`}

              Build ID: {`${process.env.REACT_APP_CODEBUILD_BUILD_ID}`}

              Resolved Source Version: {`${process.env.REACT_APP_CODEBUILD_RESOLVED_SOURCE_VERSION}`}
          </div>
          <Home />
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
